import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WhatsAppContactCard } from "@/components/WhatsAppContactCard";
import { supabase } from "@/lib/supabase";

type Row = { id: string; slug: string; name: string; logo_url: string | null };

export function AssociationsListPage() {
  const [rows, setRows] = useState<Row[]>([]);

  useEffect(() => {
    void supabase
      .from("associations")
      .select("id,slug,name,logo_url")
      .order("name")
      .then(({ data }) => setRows((data as Row[]) ?? []));
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 py-14">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-brand-maroon">
        Associations
      </p>
      <h1 className="mt-2 font-display text-4xl font-bold text-brand-blue">
        Associations
      </h1>
      <p className="mt-4 max-w-2xl text-brand-blue/85">
        Association pages can show a logo, description, executive committee
        photo, projects, and news.
      </p>
      <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rows.length === 0 && (
          <li className="text-sm text-brand-blue/60 col-span-full">
            No associations yet — add them in the admin console.
          </li>
        )}
        {rows.map((a) => (
          <li key={a.id}>
            <Link
              to={`/alumni/associations/${a.slug}`}
              className="flex h-full flex-col rounded-2xl border border-brand-gray bg-white p-6 shadow-sm transition hover:border-brand-maroon/40"
            >
              <div className="flex gap-4">
                {a.logo_url ? (
                  <img
                    src={a.logo_url}
                    alt={`${a.name} logo`}
                    className="h-16 w-16 shrink-0 rounded-xl border border-brand-gray bg-white object-contain p-1.5"
                  />
                ) : null}
                <div className="min-w-0 flex-1">
                  <span className="font-display text-lg font-bold text-brand-blue block">
                    {a.name}
                  </span>
                </div>
              </div>
              <span className="mt-4 text-xs font-bold uppercase tracking-wide text-brand-maroon">
                View association →
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <WhatsAppContactCard
        className="mt-14 max-w-2xl"
        title="Register your association"
        description="Use this if your alumni association needs a page on this site. Please contact us via WhatsApp for association registration only."
        prefilledMessage="Hello, I would like to register our alumni association with the OBA Zahira College Mawanella (please include association name if known)."
        buttonLabel="Message us on WhatsApp"
      />
    </div>
  );
}
